/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const invoiceEmailSettingsDataSchema = z.object({
	sendInvoiceEmails: z.boolean().default(true),
	sendReceiptEmails: z.boolean().default(true),
	sendInvoiceForZeroEuro: z.boolean().default(false),
	sendInvoiceForFullyPaidByWallet: z.boolean().default(false),
	sendReceiptForWalletPayments: z.boolean().default(false),
	sendInvoiceForFullyPaidAtIssue: z.boolean().default(true),
})

export type InvoiceEmailSettingsDataSchema = z.infer<typeof invoiceEmailSettingsDataSchema>
